<template>
  <div class="loginBox">
    <h1>Reset password</h1>
      <div v-if="errors.length" class="errorCard">
        <p v-for="error in errors" :key="error">
          {{ error }}
        </p>
      </div>
      <form v-if="step==1" @submit.prevent="submit">
        <input type="password" v-model="password" placeholder="Password" :disabled="loading" />
        <input type="password" v-model="password_confirmation" placeholder="Confirm password" :disabled="loading" />
        <button class="btn primary" :disabled="loading">Submit</button>
      </form>
      <div v-else>
        <p style="color: black;">
          Your password are reset you can reconnect.
        </p>
        <a href="/login" class="btn">Login</a>
      </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    login:null,
    password:null,
    password_confirmation:null,
    loading: false,
    errors: [],
    token: null,
    step:1,
  }),
  mounted () {
    this.token = this.$route.query.token
    this.email = this.$route.query.email
    if(!this.token || !this.email) {
      this.$router.push('/')
    }
  },
  methods:{
    submit(){
      this.errors = []
      if(this.password && this.password == this.password_confirmation){
        this.loading = true
        this.$store.dispatch("auth/resetPassword",{
          password:this.password,
          password_confirmation:this.password_confirmation,
          email: this.email,
          token: this.token
        }).then(() => {
          this.step++
        }).catch(({data}) => {
          if(data.errors){
            console.log(data.errors)
            for (const entry of Object.entries(data.errors)) {
              this.errors.push(entry[1].join(","))
            }
          }else if(data.message){
            this.errors.push(data.message)
          }
        }).finally(() => {
          this.loading = false
        })
      }else{
        this.errors.push('Enter a valid passord, and check your password confirmation')
      }
    }
  }
}
</script>

<style lang="less">
.loginBox{
    text-align: left;
    max-width: 500px;
    width: 100%;
    background-color: #fff;
    padding: 50px;
    margin: 50px 0;
    h1{
      font-size: 24px;
      color: #2F2B2B;
      margin-bottom: 50px;
      font-weight: 800;
    }
    hr{
      border-color: transparent;
      margin-bottom: 30px;
      margin-top: 30px;
      display: block;
    }
    .errorCard{
      padding: 10px;
      margin-bottom: 25px;
      border-radius: 10px;
      background-color: #ef5350;
      color:#FFEBEE;
      p{
        line-height: 1.5em;
      }
    }
  }
</style>